import Bugsnag from "@bugsnag/js";
import { FunctionComponent, useEffect, useState } from "react";
import BannerKountries from "@Components/molecules/BannerKountries";
import NotificationsArea from "@Components/molecules/cart/NotificationsArea";
import NotificationsProvider from "@Components/NotificationsStateProvider";
import Category from "@Components/organisms/Category";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import WithGlobalLoader, { useGlobalLoader } from "@Components/WithGlobalLoader";
import CheerzApiProvider from "@Providers/CheerzApiProvider";
import UserContent from "@Types/user";
import { getCsrfToken } from "@Utils/meta";
import { convertUserFromApiToContent } from "@Utils/user";

interface Props {
  localizationSlug: string;
  tag: string;
  type: "category" | "collection";
}

const CategoryPage: FunctionComponent<Props> = ({ localizationSlug, tag, type }) => {
  const [user, setUser] = useState<UserContent>();
  const { setLoading } = useGlobalLoader();

  useEffect(() => {
    setLoading(true);
    const cheerzApiProvider = new CheerzApiProvider(localizationSlug, getCsrfToken(), true);

    cheerzApiProvider
      .getUser()
      .then((userData) => {
        setUser(convertUserFromApiToContent(userData));
      })
      .catch((error: Error) => {
        Bugsnag.notify(error);
      });
  }, []);

  if (user) {
    return (
      <>
        <BannerKountries />
        <Header userData={user} />
        <div className="Header-notifications">
          <NotificationsArea />
        </div>
        <Category tag={tag} type={type} userData={user} />
        <Footer userData={user} />
      </>
    );
  } else return null;
};

const CategoryPageContainer: FunctionComponent<Props> = ({ localizationSlug, tag, type }) => {
  return (
    <WithGlobalLoader initialLoading={true}>
      <NotificationsProvider>
        <CategoryPage localizationSlug={localizationSlug} tag={tag} type={type} />
      </NotificationsProvider>
    </WithGlobalLoader>
  );
};

export default CategoryPageContainer;
